import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link, useLocation } from "react-router-dom";
import Repo from "../../Utility/Repo";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import Select from "../../Components/Select";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Subscription(props) {
  const apiToken = useContext(TokenContext);
  let query = useQuery();

  const [changeArray, setChangeArray] = useState(false);
  const [subscriptionsList, setSubscriptionsList] = useState();
  const [subscriptionsListTemp, setSubscriptionsListTemp] = useState();
  const [subscriptionsListTemp2, setSubscriptionsListTemp2] = useState();
  const [loading, setLoading] = useState(true);

  const [stati] = useState([
    { label: "RICHIESTA INVIATA", value: "ADDED" },
    { label: "RICHIESTA APPROVATA", value: "VALIDATED" },
    { label: "ISCRIZIONE SOSPESA", value: "SUSPENDED" },
    { label: "ISCRIZIONE RIFIUTATA", value: "REFUSED" },
  ]);

  const getOptionLabel = (option) => {
    const selectedStateObj = stati.find(
      (state) => state.value === option.value
    );
    return selectedStateObj ? selectedStateObj.label : "";
  };

  useEffect(() => {
    setLoading(false);
    Repo.getIscrizioni(apiToken)
      .then((response) => {
        setSubscriptionsListTemp(response.data.subscriptions);

        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  var filterSub = (e) => {
    if (e) {
      setChangeArray(true);

      var arr = subscriptionsListTemp.filter(function (obj) {
        return obj.state.toUpperCase() == e.value;
      });

      setSubscriptionsListTemp2(arr);
    } else {
      setChangeArray(false);
    }
  };

  const stateMappings = {
    VALIDATED: {
      icon: "it-check-circle ",
      text: "Richiesta approvata",
      color: "text-success icon-success",
    },
    SUSPENDED: {
      icon: "it-ban",
      text: "Iscrizione sospesa",
      color: "text-dark",
    },
    ADDED: {
      icon: "it-warning-circle",
      text: "Richiesta inviata",
      color: "text-warning",
    },
    REFUSED: {
      icon: "it-close-circle",
      text: "",
      color: "text-danger",
    },
  };

  return (
    <>
      <h1>Iscrizioni</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>Tutte le tue iscrizioni</p>
      </div>

      <div className="row mt-4 mb-5 ">
        <div className="col-lg-6 clearfix">
          <div className="bootstrap-select-wrapper col-12">
            <Select
              aria-label="Stato"
              clearText="Annulla"
              defaultMenuIsOpen={false}
              required
              icon={false}
              name="stato"
              id="stato"
              options={stati}
              onChange={(e) => filterSub(e)}
              isClearable
              isSearchable
              placeholder={"Seleziona stato iscrizione"}
            />
          </div>
        </div>
      </div>

      <div className="row mt-1">
        {subscriptionsList && subscriptionsList.length > 0 ? (
          subscriptionsList.map((x) => (
            <div key={x.id} className="col-12 col-lg-12">
              <Link
                to={"/iscrizioni/visualizza_categoria?id=" + x.announcementId}
                className="text-decoration-none"
              >
                <div className="card-wrapper card-space cardCustom">
                  <div className="card card-bg no-after roundedCustom p-2 ">
                    <div className="card-body">
                      <h5 style={{ fontSize: "26px" }} className="card-title">
                        {x.announcement.name}
                      </h5>
                      <div className="row">
                        <div className="col-12">
                          <p style={{ fontSize: "20px" }} className="card-text">
                            Intervento:{" "}
                            <strong>{x.announcement.service.name}</strong>
                          </p>
                        </div>
                        {x.state == "VALIDATED" && (
                          <>
                            <div className="col-12 mt-2">
                              <p
                                style={{ fontSize: "20px" }}
                                className="card-text"
                              >
                                Costo Mensile:{" "}
                                <strong>
                                  {x.cost &&
                                    parseFloat(x.cost).toLocaleString("it-IT")}
                                  {" € "}
                                </strong>
                              </p>
                            </div>
                            <div className="col-12 mt-2">
                              <p
                                style={{ fontSize: "20px" }}
                                className="card-text"
                              >
                                Ore Settimanali: <strong>{x.weeklyHour}</strong>
                              </p>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="it-card-footer">
                        <span>
                          {stateMappings[x.state] && (
                            <>
                              <svg
                                className={`icon icon-${
                                  stateMappings[x.state].icon
                                } mx-2 mb-1 ${stateMappings[x.state].color}`}
                              >
                                <use
                                  xlinkHref={`${iconSprite}#${
                                    stateMappings[x.state].icon
                                  }`}
                                ></use>
                              </svg>
                              <b
                                className={`${
                                  stateMappings[x.state].color
                                } text-uppercase`}
                              >
                                {stateMappings[x.state].text}
                              </b>
                            </>
                          )}
                        </span>

                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                        >
                          <span>Dettaglio</span>
                          <span>
                            <svg className="icon icon-primary icon-sm">
                              <use href={`${iconSprite}#it-arrow-right`} />
                            </svg>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <div>Non sei iscritto a nessun intervento</div>
        )}

        {subscriptionsListTemp &&
          (changeArray == false ? (
            <Pagination
              key={subscriptionsListTemp + changeArray}
              items={subscriptionsListTemp}
              setCurrentItems={setSubscriptionsList}
              itemsPerPage={5}
            ></Pagination>
          ) : (
            <Pagination
              key={subscriptionsListTemp2 + changeArray}
              items={subscriptionsListTemp2}
              setCurrentItems={setSubscriptionsList}
              itemsPerPage={5}
            ></Pagination>
          ))}
      </div>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default Subscription;
